<app-icon [name]="name" class="text-red-alert text-32 is-large has-spacing-bottom-xxs"></app-icon>